import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map, tap} from "rxjs/operators";
import {loginSuccess} from "../../store/Authentication/authentication.actions";
import {Route, Router} from "@angular/router";
import {SessionService} from "./session.service";
import {JwtTokenClaimsConstants} from "../../constants/jwt-token-claims-constants";
import {AuthenticationApiImplService} from "../../api/services/authentication-api-impl.service";

@Injectable({
  providedIn: 'root'
})
export class RealAuthenticationService {

  private apiUrl = 'http://localhost:8080';

  constructor(private http: HttpClient, private router: Router, private sessionService: SessionService, private authService: AuthenticationApiImplService) {
  }

  // login(username: string, password: string): Observable<any> {
  //   // Make an HTTP POST request to your real backend's login endpoint
  //   return this.http.post<any>(`${this.apiUrl}/authenticate`, { username, password });
  // }

  login(credentials: { username: string; password: string }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/authenticate`, credentials).pipe(
      map((user) => {
        // Handle the response from the real backend
        localStorage.setItem(JwtTokenClaimsConstants.CURRENT_USER, JSON.stringify(user));
        localStorage.setItem(JwtTokenClaimsConstants.TOKEN, user.token);
        localStorage.setItem(JwtTokenClaimsConstants.USER_ID, this.getUserId(user.token) + '');
        localStorage.setItem(JwtTokenClaimsConstants.AUTHORITIES, this.getAuthorities(user.token));
        localStorage.setItem(JwtTokenClaimsConstants.USER_SID, this.getUserSid(user.token));
        localStorage.setItem(JwtTokenClaimsConstants.PROJECT_IDS, this.getProjectIds(user.token));
        localStorage.setItem('exp', this.getExp(user.token));
        this.router.navigate(['/']);
        return loginSuccess({user});
      })
    );
  }

  logout() {
    localStorage.removeItem(JwtTokenClaimsConstants.TOKEN);
    localStorage.removeItem(JwtTokenClaimsConstants.CURRENT_USER);
    localStorage.removeItem(JwtTokenClaimsConstants.USER_ID);
    localStorage.removeItem(JwtTokenClaimsConstants.AUTHORITIES);
    localStorage.removeItem(JwtTokenClaimsConstants.USER_SID);
    localStorage.removeItem('exp');
  }

  refreshToken(lang: string): void {

    this.authService.refreshToken({lang: lang}).subscribe((res) => {
      this.logout();
      const refreshedToken = res.token;
      localStorage.setItem(JwtTokenClaimsConstants.CURRENT_USER, JSON.stringify(refreshedToken));
      localStorage.setItem(JwtTokenClaimsConstants.TOKEN, refreshedToken);
      localStorage.setItem(JwtTokenClaimsConstants.USER_ID, this.getUserId(refreshedToken) + '');
      localStorage.setItem(JwtTokenClaimsConstants.AUTHORITIES, this.getAuthorities(refreshedToken));
      localStorage.setItem(JwtTokenClaimsConstants.USER_SID, this.getUserSid(refreshedToken));
      localStorage.setItem(JwtTokenClaimsConstants.PROJECT_IDS, this.getProjectIds(refreshedToken));
      localStorage.setItem('exp', this.getExp(refreshedToken));
    })
  }

  private getUserId(token: string): number | null {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.userId || null;
      } catch (error) {
        console.error('Error parsing token payload', error);
      }
    }
    return null;
  }

  private getAuthorities(token: string): string | null {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.authorities || null;
      } catch (error) {
        console.error('Error parsing token payload', error);
      }
    }
    return null;
  }

  private getUserSid(token: string): string | null {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.userSid || null;
      } catch (error) {
        console.error('Error parsing token payload', error);
      }
    }
    return null;
  }

  private getProjectIds(token: string): string | null {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.projectIds || null;
      } catch (error) {
        console.error('Error parsing token payload', error);
      }
    }
    return null;
  }

  private getExp(token: string): string | null {
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.exp || null;
      } catch (error) {
        console.error('Error parsing token payload', error);
      }
    }
    return null;
  }

  getAuthoritiesList(): Array<string> {
    const authorities = localStorage.getItem('authorities');
    return authorities?.split(',');
  }

  containsRoles(roles: Array<string>): boolean {
    return this.getAuthoritiesList().some(value => roles.includes(value));
  }

  getLocalStorageUserId(): number {
    return Number(localStorage.getItem('userId'));
  }

  getLocalStorageUserSid(): string {
    return localStorage.getItem('userSid');
  }

  getLocalStorageExp(): string {
    return localStorage.getItem('exp');
  }
}
